module.exports = __webpack_public_path__ + "3198bd6ad81f6b957d93f486773566b9.jpg";